export default "__VITE_ASSET__CjRJdr9E__"